import React, { useCallback } from 'react'

import { posthog } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

import { EnvVariables, isProduction } from './constants'
import { MonitoringContextKey } from './utils/monitoring'

type Props = {
  children: React.ReactNode
}
export const GWPostHogProvider = ({ children }: Props) => {
  const isProd = isProduction()

  // Initialize PostHog global properties once PostHog has loaded
  const onLoad = useCallback(() => {
    posthog.register({
      [MonitoringContextKey.IsProduction]: isProd,
    })
  }, [isProd])

  return (
    <PostHogProvider
      apiKey={EnvVariables.PostHogKey}
      options={{
        api_host: EnvVariables.PostHogHost,
        defaults: '2025-05-24',
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking
        debug: false, // Enable to see detailed posthog console logs
        loaded: onLoad,
      }}
    >
      {children}
    </PostHogProvider>
  )
}
